import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HsnSacApi } from '../api/hsnsac.api';
import { switchMap, map } from 'rxjs/operators';

import { HsnSacData, HsnSac } from '../../../interfaces/masters/hsn-sac' ;
@Injectable()
export class HsnSacService extends HsnSacData {

    constructor(private api: HsnSacApi) {
      super();
    }
  
  
    list(url: string): Observable<HsnSac[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<HsnSac>{
        return this.api.getById(url);
    }
  
    create(url: string, data:HsnSac): Observable<HsnSac[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:HsnSac): Observable<HsnSac> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  